import {
  FLYOUT_FAILOVER_LOCAL_STORAGE_FEATURE_KEY,
  IDAM_AUTH_LOCAL_STORAGE_FEATURE_KEY,
  LOCAL_STORAGE_FEATURE_ENABLED_VALUE,
  METRO_CARD_LOCAL_STORAGE_FEATURE_KEY,
  SEARCH_VERSION_LOCAL_STORAGE_KEY,
  SF_HP_SELLER_BANNER,
  CART_UPDATE_LOCAL_STORAGE_FEATURE_KEY,
  FREE_SHIPPING_THRESHOLD_IN_PDP,
  FLIXMEDIA_DYSON_INTEGRATION
} from './localstorage.constant';

export const QUERY_FF_PREFIX = 'ff_';

export const ACCEPTABLE_QUERY_ON_VALUES = [LOCAL_STORAGE_FEATURE_ENABLED_VALUE, '1'];

export const QUERIES_ACCEPT_OTHER_VALUES = [SEARCH_VERSION_LOCAL_STORAGE_KEY];

export const FLUSH_LOCAL_STORAGE_FEATURES_ON_REFRESH_KEY = 'on_refresh_flush_ff';
export const RESET_ALL_FEATURES_QUERY_KEY = 'ff_reset_ff';

export const LOCALSTORAGE_FEATURES_WHITELIST = [
  IDAM_AUTH_LOCAL_STORAGE_FEATURE_KEY,
  FLYOUT_FAILOVER_LOCAL_STORAGE_FEATURE_KEY,
  METRO_CARD_LOCAL_STORAGE_FEATURE_KEY,
  CART_UPDATE_LOCAL_STORAGE_FEATURE_KEY,
  SEARCH_VERSION_LOCAL_STORAGE_KEY,
  SF_HP_SELLER_BANNER,
  FLUSH_LOCAL_STORAGE_FEATURES_ON_REFRESH_KEY,
  FREE_SHIPPING_THRESHOLD_IN_PDP,
  FLIXMEDIA_DYSON_INTEGRATION
];
